import type { BracketSlot, PickemTeam } from '../types'

/** Команда для отрисовки слота: пик'эм — user-cascade, результат — официальная сетка. */
export const getBracketSlotDisplayTeam = (
  slot: BracketSlot,
  resultsView: boolean
): PickemTeam | null => (resultsView ? slot.team : slot.effective_team ?? null)

/** Слот с `team`, подставленной для UI (MatchSlot, aria, labels). */
export const toBracketDisplaySlot = (
  slot: BracketSlot,
  resultsView: boolean
): BracketSlot => ({
  ...slot,
  team: getBracketSlotDisplayTeam(slot, resultsView)
})
